import React from 'react'

import { Skeleton } from '@mui/material'

import EnterpriseReportBox from './EnterpriseReportBox'
import styles from './TimeSavedSection.module.scss'

interface TimeSavedSectionProps {
  loading: boolean
  timeSaved?: {
    total: number
    avgTimeSavedPerUser: number
  } | null
}

function TimeSavedHeader({
  title,
  loading,
  value,
}: {
  title: string
  loading: boolean
  value: string
}) {
  return (
    <div className={styles.timeSavedHeader}>
      <h3 className={styles.timeSavedTitle}>{title}</h3>
      <div className={styles.timeSavedValue}>
        {loading ? <Skeleton width={60} /> : value}
      </div>
    </div>
  )
}

export default function TimeSavedSection({
  loading,
  timeSaved,
}: TimeSavedSectionProps) {
  const formatTimeValue = (minutes: number): string => {
    let years = 0
    let months = 0
    let days = 0
    let hours = 0
    let mins = 0

    if (minutes < 60) {
      mins = minutes
    } else {
      hours = Math.floor(minutes / 60)
      mins = minutes % 60
    }

    if (hours >= 24) {
      days = Math.floor(hours / 24)
      hours %= 24
    }

    if (days >= 30) {
      months = Math.floor(days / 30)
      days %= 30
    }

    if (months >= 12) {
      years = Math.floor(months / 12)
      months %= 12
    }

    return [
      `${years > 0 ? `${years} year${years !== 1 ? 's' : ''}` : ''}`,
      `${months > 0 ? `${months} month${months !== 1 ? 's' : ''}` : ''}`,
      `${days > 0 ? `${days} day${days !== 1 ? 's' : ''}` : ''}`,
      `${hours > 0 ? `${hours} hour${hours !== 1 ? 's' : ''}` : ''}`,
      `${mins > 0 ? `${mins} minute${mins !== 1 ? 's' : ''}` : ''}`,
    ]
      .filter(Boolean)
      .join(', ')
  }

  const totalTimeValue = timeSaved?.total
    ? formatTimeValue(timeSaved.total)
    : '0 min'

  const avgTimeValue = timeSaved?.avgTimeSavedPerUser
    ? formatTimeValue(Math.round(timeSaved.avgTimeSavedPerUser))
    : '0 min'

  return (
    <EnterpriseReportBox
      header={
        <TimeSavedHeader
          title="Total time saved"
          loading={loading}
          value={totalTimeValue}
        />
      }
      content={
        <div className={styles.timeSavedContent}>
          <div className={styles.timeSavedContentTitle}>
            Average time saved per user
          </div>
          <div className={styles.timeSavedContentValue}>{avgTimeValue}</div>
        </div>
      }
    />
  )
}
